import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { EMessageTypes, EDepositStatus } from "src/types";

export const useReceiveDepositStatusRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === EMessageTypes.DepositStatusRedirect && event.data?.status) {
        const status = event.data.status as EDepositStatus;
        navigate(`/deposit-status/${status}`, { replace: true });
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [navigate]);
};
